import type * as core from '../../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.assets',
    'package:data.higherEd.orgStructureSpace',
    'resource:data.dimensions.depreciation',
    'resource:data.dimensions.depreciation.entities.entry',
    'resource:data.dimensions.depreciation.entities.entry.attributes.federalAmount',
    'resource:data.dimensions.depreciation.entities.entry.attributes.asset',
    'resource:data.dimensions.depreciation.entities.entry.attributes.amount',
    'resource:data.dimensions.depreciation.entities.entry.attributes.adjustmentAmount',
    'resource:data.dimensions.capitalProjects',
    'resource:data.dimensions.capitalProjects.entities.capitalProject',
    'resource:data.dimensions.capitalProjects.entities.capitalProject.attributes.space',
    'resource:data.dimensions.capitalProjects.entities.capitalProject.attributes.organization',
    'resource:data.dimensions.capitalProjectInterest',
    'resource:data.dimensions.capitalProjectInterest.entities.entry',
    'resource:data.dimensions.capitalProjectInterest.entities.entry.attributes.federalAmount',
    'resource:data.dimensions.capitalProjectInterest.entities.entry.attributes.capitalProject',
    'resource:data.dimensions.capitalProjectInterest.entities.entry.attributes.amount',
  ],
  description: 'TODO',
  name: 'IDC Data - Depreciation & Interest',
} as const satisfies core.quiver.Package
